import { render, staticRenderFns } from "./Slug.vue?vue&type=template&id=bd684320&scoped=true&"
import script from "./Slug.vue?vue&type=script&lang=js&"
export * from "./Slug.vue?vue&type=script&lang=js&"
import style0 from "./Slug.vue?vue&type=style&index=0&id=bd684320&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd684320",
  null
  
)

export default component.exports